// tuning/net.ts (M0-T06, §7.2)
import type { TuningBank } from '../schema/tuning';

export default {
  chatPerSec: 1, chatBurst: 3, chatMaxChars: 140, actionsPerSec: 10, actionBurst: 10, movesPerSec: 15,
  maxMsgBytes: 2048, presenceGraceMs: 30_000, moveSendHz: 10, relayHz: 10, interpDelayMs: 100,
  extrapolateMs: 150, snapTiles: 3, clockPings: 5, clockPingGapMs: 200,
  ticketTtlMs: 60_000, clockResyncMs: 60_000, helloTimeoutMs: 10_000, heartbeatMs: 8_000, deadAfterMs: 4_000,
  // the client gives a fresh connect helloTimeoutMs to reach its snapshot; deadAfterMs applies only once live (heartbeat, foreground check)
  silentDropMs: 30_000,      // the town drops a socket silent this long (a half-open link). Longer than the client's own heartbeatMs +
                             // deadAfterMs: a client busy for a while (a slow phone's first frame) is not dropped; a dead one notices itself
  presenceSweepMs: 10_000,   // how often the town checks for half-open sockets (silent for silentDropMs) while anyone is live
  reconnectBackoffMs: [500, 1000, 2000, 4000, 8000, 15_000], reconnectJitter: 0.2, strikesToClose: 5, strikeWindowMs: 60_000,
  chatHistory: 50, actionTimeoutMs: 8000,
} as const satisfies TuningBank;
